var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "container" }, [
    _c(
      "header",
      { staticClass: "header" },
      [
        _c(
          "el-tabs",
          {
            staticStyle: { width: "100%" },
            model: {
              value: _vm.activeName,
              callback: function ($$v) {
                _vm.activeName = $$v
              },
              expression: "activeName",
            },
          },
          [
            _c(
              "el-tab-pane",
              { attrs: { label: "评价列表", name: "1" } },
              [_c("evaluateList")],
              1
            ),
            _c(
              "el-tab-pane",
              { attrs: { label: "投诉列表", name: "2" } },
              [_c("complaintList")],
              1
            ),
            _c(
              "el-tab-pane",
              { attrs: { label: "回复模版设置", name: "3" } },
              [_c("replyTele")],
              1
            ),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }